export default {
  namespaced: true,
  state: {
    trackId: false,
  },
  mutations: {
    setTrackId(state, trackId) {
      state.trackId = trackId;
    },

  },
  actions: {
    setTheTrackId({ commit }, trackId) {
      commit('setTrackId', trackId);
    },
  },
  getters: {
    getTrackId: (state) => state.trackId,
  },
};
